import { openBlock as l, createElementBlock as o, createElementVNode as e } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, c = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M7.687 3.941A.75.75 0 0 1 8.37 3.5h7.27a.75.75 0 0 1 .683.441l.497 1.097.268.594.035.078h2.607v1.5h-3.089a.751.751 0 0 1-.672-.415c-.013-.025-.245-.539-.473-1.043L15.156 5H8.854l-.79 1.749a.75.75 0 0 1-.684.441H5.162a.75.75 0 0 1-.122.01h-.79V19h15.5V7.211a.192.192 0 0 0-.02-.001v-1.5c.722 0 1.52.514 1.52 1.4v12.64a.75.75 0 0 1-.75.75H4.27c-.664 0-1.52-.446-1.52-1.35V7.05c0-.446.238-.799.517-1.016.28-.217.637-.334 1.003-.334h.658a.75.75 0 0 1 .122-.01h1.846l.79-1.749Z",
  "clip-rule": "evenodd"
}, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M12 10.58a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm-4 2.5a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
  "clip-rule": "evenodd"
}, null, -1), a = [
  c,
  n
];
function d(r, h) {
  return l(), o("svg", t, [...a]);
}
const i = { render: d };
export {
  i as default,
  d as render
};
